import { AsyncPipe } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, ContentChildren, effect, ElementRef, EventEmitter, inject, Input, OnChanges, OnInit, Output, QueryList, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'core-accordion-panel',
  imports: [AsyncPipe, FontAwesomeModule],
  templateUrl: '../ui/accordion-panel.component.html',
  styleUrl: '../ui/accordion-panel.component.css'
})
export class AccordionPanelComponent{
  private readonly elementRef: ElementRef = inject(ElementRef)
  @Input() header: string = '';
  @Output() toggle: EventEmitter<void> = new EventEmitter<void>();
  @Input() active: WritableSignal<boolean> = signal(false);
  @Input() completed: WritableSignal<boolean> = signal(false);
  index$ = new BehaviorSubject<number>(0)
  linear: boolean = false;
  numbered:boolean = true;

  get nativeElement() {
    return this.elementRef.nativeElement;
  }

  setIndex(index:number){
    this.index$.next(index);
  }

}

@Component({
  selector: 'core-accordion',
  imports: [],
  templateUrl: '../ui/accordion.component.html',
  styleUrl: '../ui/accordion.component.css'
})
export class AccordionComponent implements AfterContentInit, OnChanges{
  @ContentChildren(AccordionPanelComponent) panels?: QueryList<AccordionPanelComponent>
  @Input() value: number = 0;
  @Input() linear: boolean = false;
  @Input() numbered: boolean = true;

  ngAfterContentInit(): void {
    this.panels?.forEach((panel, index) => {
      panel.index$.next(index + 1);
      //panel.index = index + 1;
      panel.linear = this.linear;
      panel.numbered = this.numbered;
      if (index === 0) {
        panel.active.set(true);
      }
      panel.toggle.subscribe(() => {
        if (!this.linear){
          this.toggleAccordion(index)
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
      this.toggleAccordion(this.value);
  }

  toggleAccordion(index: number) {
    this.value = index;
    this.panels?.forEach((panel, i) => {
      panel.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      panel.active.set(this.value === i);
    });
  }
}